import * as React from "react";
import get from "lodash/get";

import "./TextInput.css";
import * as actions from "../../actions";
import { isEditMode } from "../../utils/sendClickToMerchant";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { flattenObject } from "../../utils/flattenObject";
import { generateErrorId } from "../../utils/string";

export interface TextInputProps extends ComponentBaseProps {
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  errorMessage?: string;
  configName: string;
  placeholder?: string;
  style?: React.CSSProperties;
  type?: "text" | "number";
  value: string;
}

export class TextInput extends ComponentBase<TextInputProps> {
  handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.onFormChange(event.target.value);
  };

  onBlur = () => {
    if (isEditMode()) {
      return;
    }

    const formErrors = flattenObject(get(this.props, "formErrors", {}));

    if (formErrors[this.props.name]) {
      this.validateField(true);
    }
  };

  render() {
    const { style, placeholder, name, type = "text", data } = this.props;
    const value = get(data, name);
    const isPreviewMode = !isEditMode();
    const formErrors = flattenObject(get(this.props, "formErrors", {}));
    const hasError = formErrors[this.props.name];

    return (
      <input
        id={this.props.configName}
        onDragStart={this.onDragStart}
        min={type === "number" ? 0 : ""}
        step={type === "number" ? "1" : ""}
        type={type}
        placeholder={placeholder}
        value={value || ""}
        style={style}
        className={`TextInput-input ${hasError ? "input-error" : ""} ${
          isPreviewMode ? "TextInput-input-preview" : ""
        }`}
        onChange={this.handleOnChange}
        onBlur={this.onBlur}
        aria-label={get(this.props, "label", "")}
        {...(hasError
          ? { "aria-describedby": generateErrorId(this.props.name) }
          : {})}
        tabIndex={0}
        ref={(component) => (this.component = component)}
      />
    );
  }
}
